<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="img"><a id="fig1-1"><img alt="image" src="images/1_1.jpg" style="height: auto; max-height: 100%; width: auto; max-width: 100%; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/></a></p><a id="fig1-1">
<p class="caption"><span><i>Figure</i> <b><span class="color1">1.1</span></b> | <i>This boy runs on the beach in the most pure and natural way.</i></span></p>
</a></div><a id="fig1-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap01fig01.vue?346e212e